import cx from "ui/cx";
import styles from "./LoadingDots.module.scss";

export type LoadingDotsProps = React.HTMLAttributes<HTMLDivElement>;

export default function LoadingDots({ children, className, ...props }: LoadingDotsProps) {
  return (
    <div className={cx(styles.wrapper, className)} {...props}>
      {children}
      <span>.</span>
      <span>.</span>
      <span>.</span>
    </div>
  );
}
